import { colors } from '../utils'

export default {
  namespaced : true,
  state      : {
    styles   : colors.createColorTheme(),
  },
  mutations  : {
    reset    : ( state, hue ) => state.styles = colors.createColorTheme( hue ),
  }
}
